import { app } from '../../../app';
import { Controller } from './company-registration.controller';

app.component('companyRegistration', {
    templateUrl: require('./company-registration.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/company-registration/company-registration.component.js